
// 当前系统UA信息
export const CURRENT_ENV_UA = window.navigator.userAgent.toLowerCase() || ''
// 学而思网校App(素质) UA
export const UA_WANGXIAO = 'jzh'
// 高中App UA
export const UA_GAOZHOGN = 'hs'
// 新学科App
export const UA_XINXUEKE = 'subject_jzh'

// 学而思网校App(素质) Schema
export const SCHEMA_WANGXIAO = 'xeswangxiao'
// 高中App Schema
export const SCHEMA_GAOZHOGN = 'xeswxhs'
// 新学科App Schema
export const SCHEMA_XINXUEKE = 'xeswxsubject'

//  学而思网校(素质) biz
export const BIZ_SUZHI = 10
// 高中 biz
export const BIZ_GAOZHOGN = 20
// 新学科 biz
export const BIZ_XINXUEKE = 30
// 学而思网校 biz
export const BIZ_WANGXIAO = 10
// bizid参数名
export const BIZ_ID_KEY = 'X-Businessline-Id'

// 当前地址HOST值
export const CURRENT_HOST = window.location.host

// BIZID参数名称
export const QUERY_BIZID_NAME = 'app_blid'



// WEBPACK FOOTER //
// ./node_modules/@xes/trade-toolkit/src/const.js